import { useState } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import { faHeading } from '@fortawesome/pro-light-svg-icons';
import { green, red } from '@mui/material/colors';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import Header from '../Header';

const SCREENS = [{
    key: 'price-quote',
    title: 'Price Quotes Header',

}, {
    key: 'price-quote-mobile',
    title: 'Price Quotes Header (mobile)',

}, {
    key: 'agent-query',
    title: 'Agent Query Header',
}, {
    key: 'agent-query-mobile',
    title: 'Agent Query Header (mobile)',
}]

function Headers() {
    const { org, accesstoken } = useOutletContext();
    const [ screen, setScreen ] = useState('price-quote');
    const [ html, setHtml ] = useState(_.fromPairs(_.map(SCREENS, s => ( [s.key, (org.headers || {})[s.key] || '']))));
    const [ saving, setSaving ] = useState(false);
    const [ savingSuccess, setSavingSuccess ] = useState(null);
    const [ errors, setErrors ] = useState([]);

    async function onSave() {
        setSaving(true);
        try {
            await axios.post(`/api/organizations/${org.id}/headers?accesstoken=${accesstoken}`, html);
            setSaving(false);
            setSavingSuccess('yes');
        } catch(e) {
            setSaving(false);
            setSavingSuccess('no');
            setErrors([e.message]);
            console.log('Error saving:', e);
        }

        await new Promise(res => setTimeout(res, 3000));
        setSavingSuccess(null);
    }

    return (
        <Box>
            <Header
                icon={faHeading}
                title={'Headers'}
                tabs={_.map(SCREENS, s => ({
                    title: s.title,
                    action: () => setScreen(s.key),
                    selected: s.key === screen
                }))}
                buttons={[{
                    title: 'Save',
                    icon: savingSuccess === 'yes' ? faCheck : savingSuccess === 'no' ? faXmark : null,
                    iconColor: savingSuccess === 'yes' ? green[500] : savingSuccess === 'no' ? red[500] : null,
                    width: '80px',
                    color: 'monada-button',
                    action: onSave,
                    thinking: saving,
                    disabled: saving || !!savingSuccess,
                }]}
            />
            {errors.length > 0 && (
                <Alert severity='error' sx={{ marginBottom: '12px' }}>
                    <div>
                        Sorry, there was an error saving:<br/>
                    </div>
                    <ul>
                        {errors.map(e => (
                            <li key={e}>{e}</li>
                        ))}
                    </ul>
                </Alert>
            )}
            <Box sx={{ p: 3 }}>
                {(screen.indexOf('-mobile') === -1) && (
                    <Box style={{ paddingTop: '12px' }}>
                        <Typography variant='caption'>
                            To get the most out of your header images on desktop, we suggest using W: 2732 x H: 256 pixels resolution.
                        </Typography>
                    </Box>
                )}

                {(screen.indexOf('-mobile') > -1) && (
                    <Box style={{ paddingTop: '12px' }}>
                        <Typography variant='caption'>
                            To get the most out of your header images on mobile devices, we suggest using W: 750 x H: 166 pixels resolution.
                        </Typography>
                    </Box>
                )}

                <Box style={{ paddingTop: '24px' }}>
                    <TextField
                        fullWidth
                        label='Header HTML'
                        multiline
                        rows={4}
                        value={html[screen] || ''}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setHtml({...html, [screen]: event.target.value});
                        }}
                    />
                </Box>

                <Box style={{ paddingTop: '24px' }}>
                    <Typography variant='h6'>Result</Typography>
                    <div dangerouslySetInnerHTML={{ __html: html[screen] }} />
                </Box>
            </Box>
        </Box>
    )
}

export default Headers;

